module.exports = __webpack_public_path__ + "img/logo-horizontal.fb805637.png";